import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Row, Col, Space, Typography } from 'antd';
import { MailOutlined, PhoneOutlined, EnvironmentOutlined } from '@ant-design/icons';
import BirdsBackground from '../utils/BirdsBackground';
import './Contact.scss';

const { Title, Paragraph, Text } = Typography;

const officeLatitude = 21.823;
const officeLongitude = 105.214;
const maptilerApiKey =
  process.env.REACT_APP_MAPTILER_API_KEY ||
  process.env.VITE_MAPTILER_API_KEY ||
  't53MyBkI8qTBqVhPiHK7';
const staticMapUrl = `https://api.maptiler.com/maps/streets-v2/static/pin-s+1890ff(${officeLongitude},${officeLatitude})/${officeLongitude},${officeLatitude},13/900x520@2x.png?key=${maptilerApiKey}`;
const directionsUrl = `https://www.google.com/maps/search/?api=1&query=${officeLatitude},${officeLongitude}`;
const Contact: React.FC = () => {
  const { t } = useTranslation();
  const bgRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!bgRef.current) return;
    const bg = new BirdsBackground(bgRef.current);
    return () => bg.destroy();
  }, []);

  return (
    <div className="contact-page">
      <div className="contact-vanta-bg" ref={bgRef} aria-hidden="true" />

      <div className="contact-content">
        <Title level={2} className="contact-title" style={{color: '#f8fafc'}}>
          {t('contact')}
        </Title>

        <Row gutter={[32, 32]} justify="center">
          <Col xs={24} md={16} lg={14}>
            <Card className="contact-card" style={{ height: '100%' }}>
              <Title level={4}>{t('contactPage.info.title')}</Title>

              <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <Space align="start">
                  <EnvironmentOutlined style={{ fontSize: 20, color: '#1890ff', marginTop: 4 }} />
                  <div>
                    <Text strong>{t('contactPage.info.addressLabel')}</Text>
                    <Paragraph style={{ margin: 0 }}>{t('contactPage.info.addressValue')}</Paragraph>
                  </div>
                </Space>

                <Space align="start">
                  <PhoneOutlined style={{ fontSize: 20, color: '#52c41a', marginTop: 4 }} />
                  <div>
                    <Text strong>{t('contactPage.info.hotlineLabel')}</Text>
                    <Paragraph style={{ margin: 0 }}>
                      <a href="tel:+84795227398">+84 795 227 398</a>
                    </Paragraph>
                  </div>
                </Space>

                <Space align="start">
                  <MailOutlined style={{ fontSize: 20, color: '#faad14', marginTop: 4 }} />
                  <div>
                    <Text strong>{t('contactPage.info.emailLabel')}</Text>
                    <Paragraph style={{ margin: 0 }}>
                      <a href="mailto:contact@hyconnect.vn">contact@hyconnect.vn</a>
                    </Paragraph>
                  </div>
                </Space>

                <div style={{ marginTop: 12 }}>
                  <Text strong>{t('contactPage.info.companyName')}</Text>
                  <Paragraph style={{ marginTop: 6, fontSize: 13, color: '#ffc918', marginBottom: 0}}>
                    {t('contactPage.info.taxCode', { code: '5100513815' })}
                  </Paragraph>
                </div>

                {/* <div className="contact-map">
                  <a href={directionsUrl} target="_blank" rel="noreferrer" aria-label="Open HYconnect location in Google Maps">
                    <img
                      title="HYconnect Map"
                      src={staticMapUrl}
                      alt="HYconnect office map"
                      loading="lazy"
                    />
                  </a>
                </div> */}
              </Space>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Contact;
